// print body text for FullArticleView
const BodyText = ({ text }) => {
  return <p>{text}</p>;
};

export default BodyText;
